// billing-status-visibility — shared badge tone/label maps for the org's
// EFFECTIVE subscription status, reused by both OrganizationsPage (list)
// and OrganizationDetailPage (detail/suspend screen) so the two screens
// never drift into inconsistent colors/wording for the same status. Tone
// mirrors SubscriptionPage's own STATUS_TONE (the org_admin's view of their
// OWN subscription) — same vocabulary, same colors, everywhere in the app.

import type { SubscriptionStatusDto } from '@jq4race/shared';
import type { BadgeProps } from '@jq4race/ui';

export const BILLING_STATUS_TONE: Record<SubscriptionStatusDto, BadgeProps['variant']> = {
  incomplete: 'secondary',
  active: 'success',
  past_due: 'warning',
  suspended: 'danger',
  canceled: 'secondary',
};

export const BILLING_STATUS_LABEL_KEYS: Record<SubscriptionStatusDto, string> = {
  incomplete: 'subscription:status.incomplete',
  active: 'subscription:status.active',
  past_due: 'subscription:status.pastDue',
  suspended: 'subscription:status.suspended',
  canceled: 'subscription:status.canceled',
};
